import React from 'react';
import { FiShield, FiTool, FiGlobe, FiDollarSign } from 'react-icons/fi';

const features = [
    {
        icon: <FiShield size={28} className="text-red-500 mb-3" />,
        title: "Expert Team",
        description: "Our team consists of certified cybersecurity professionals with real-world experience.",
    },
    {
        icon: <FiTool size={28} className="text-red-500 mb-3" />,
        title: "Hands-on Learning",
        description: "Practical, real-world scenarios that prepare you for actual cybersecurity challenges.",
    },
    {
        icon: <FiGlobe size={28} className="text-red-500 mb-3" />,
        title: "Local Expertise",
        description: "Content in Bahasa Indonesia, tailored to the specific needs of Indonesian organizations.",
    },
    {
        icon: <FiDollarSign size={28} className="text-red-500 mb-3" />,
        title: "Affordable Pricing",
        description: "Quality cybersecurity education accessible to students and professionals alike.",
    },
];

const WhyChoose = () => {
    return (
        <section className="bg-[#1a1a1a] text-white px-6 md:px-16 py-20 text-center">
            <h2 className="text-3xl font-bold mb-2">
                Why Choose <span className="text-red-500">SiberLab ID</span>
            </h2>
            <p className="text-gray-400 max-w-2xl mx-auto mb-12">
                We combine expertise, practical experience, and innovative teaching methods to deliver the best cybersecurity solutions.
            </p>

            <div
                className="grid gap-8 md:grid-cols-4"
                data-aos="fade-up"
                data-aos-duration="1000"
            >
                {features.map((feature, idx) => (
                    <div
                        key={idx}
                        className="flex flex-col items-center text-center px-4"
                        data-aos="fade-up"
                        data-aos-delay={idx * 100}
                    >
                        {feature.icon}
                        <h3 className="text-lg font-semibold mb-1">{feature.title}</h3>
                        <p className="text-gray-400 text-sm">{feature.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default WhyChoose;
